// Utilitário para gerenciamento de contexto de campanha de marketing
// Captura e propaga o parâmetro de campanha via localStorage

const STORAGE_KEY_ID = 'sitri_campanha_id';
const STORAGE_KEY_TS = 'sitri_campanha_ts';
const EXPIRATION_MS = 2592000000; // 30 dias em milissegundos
const MAX_CAMPANHA_LENGTH = 36;

/**
 * Inicializa o contexto de campanha a partir da URL.
 * Captura o query param `campanha`, valida e armazena no localStorage.
 * Também verifica expiração de valor previamente armazenado.
 */
export const initCampaignContext = () => {
  try {
    // Verificar expiração do valor existente
    const storedTs = localStorage.getItem(STORAGE_KEY_TS);
    if (storedTs) {
      const elapsed = Date.now() - Number(storedTs);
      if (elapsed >= EXPIRATION_MS) {
        localStorage.removeItem(STORAGE_KEY_ID);
        localStorage.removeItem(STORAGE_KEY_TS);
      }
    }

    // Capturar parâmetro da URL
    const params = new URLSearchParams(window.location.search);
    const campanha = params.get('campanha');

    // Validar: não vazio e máximo 36 caracteres
    if (campanha && campanha.length > 0 && campanha.length <= MAX_CAMPANHA_LENGTH) {
      localStorage.setItem(STORAGE_KEY_ID, campanha);
      localStorage.setItem(STORAGE_KEY_TS, String(Date.now()));
    }
  } catch (error) {
    // localStorage indisponível (ex: navegação privada) - continuar sem contexto
    return null;
  }
};

/**
 * Retorna o ID da campanha armazenado, ou null se expirado/inexistente.
 */
export const getCampaignId = () => {
  try {
    const campanhaId = localStorage.getItem(STORAGE_KEY_ID);
    const storedTs = localStorage.getItem(STORAGE_KEY_TS);

    if (!campanhaId || !storedTs) {
      return null;
    }

    const elapsed = Date.now() - Number(storedTs);
    if (elapsed >= EXPIRATION_MS) {
      localStorage.removeItem(STORAGE_KEY_ID);
      localStorage.removeItem(STORAGE_KEY_TS);
      return null;
    }

    return campanhaId;
  } catch (error) {
    // localStorage indisponível
    return null;
  }
};

/**
 * Atualiza o contexto de campanha a partir da resposta de validação de voucher.
 * @param {string} campanhaId - ID da campanha retornado pelo backend
 */
export const setCampaignFromVoucher = (campanhaId) => {
  try {
    if (campanhaId && campanhaId.length > 0) {
      localStorage.setItem(STORAGE_KEY_ID, campanhaId);
      localStorage.setItem(STORAGE_KEY_TS, String(Date.now()));
    }
  } catch (error) {
    // localStorage indisponível
    return null;
  }
};
